const allCookies = document.cookie;

function getCookieByName(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      // Remove leading whitespace
      c = c.substring(1);
    }
    if (c.indexOf(nameEQ) === 0) {
      // Check if the cookie starts with the desired name
      return c.substring(nameEQ.length, c.length); // Return the cookie value
    }
  }
  return null; // Return null if the cookie is not found
}

const discount_cookie = getCookieByName("discount_code");

const discountPercent = parseInt(discount_cookie.split("-")[1]) || 0;

if (discountPercent > 0) {
  document.querySelectorAll(".product-price").forEach((el) => {
    const originalPriceText =
      el.dataset.originalPrice || el.querySelector("span").textContent;
    console.log(originalPriceText);

    // Parse price number from text, e.g. "$100.00" -> 100
    const originalPrice = parseFloat(
      originalPriceText.replace(/[^0-9\.]+/g, "")
    );

    if (!isNaN(originalPrice)) {
      const discountedPrice = (
        originalPrice *
        (1 - discountPercent / 100)
      ).toFixed(2);
      // Show discounted price
      el.textContent = `$${discountedPrice}`;

      // Optionally add original price with strikethrough
      if (!el.dataset.originalPrice) {
        el.dataset.originalPrice = originalPriceText;
        const originalPriceEl = document.createElement("span");
        originalPriceEl.style.textDecoration = "line-through";
        originalPriceEl.style.marginLeft = "8px";
        originalPriceEl.style.color = "#999";
        originalPriceEl.textContent = originalPriceText;
        el.appendChild(originalPriceEl);
      }
    }
  });
}
